import { selectTicketTypes } from "app/redux/selector";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { ITicketFormData, TicketGroup } from "../../containers/Tickets/types";
import { useTicketCreateActions } from "../../containers/Tickets/useTicketCreateActions";
import { AssigneeButton } from "./AssigneeButton";
import { CalendarButton } from "./CalendarButton";
import { PriorityButton } from "./PriorityButton";
import TagsButton from "./TagsButton";
import { TicketStatusButton } from "./TicketStatusButton";
import { TicketTypeButton } from "./TicketTypeButton";

interface Props {
  onOpen: () => void;
  onClose: () => void;
  form: ITicketFormData;
  group: TicketGroup;
}

const Fields: React.FC<Props> = ({ onClose, onOpen, form, group }) => {
  const dispatch = useDispatch();
  const ticketTypes = useSelector(selectTicketTypes);
  const { setTicketField } = useTicketCreateActions();
  const handleSelect = (name: string, value: any) => {
    setTicketField(name as keyof ITicketFormData, value);
    dispatch(
      ticketGroupsActions.setTicketFormValue({
        name: name,
        value: value,
      }),
    );
  };
  return (
    <>
      <TicketTypeButton
        type={form?.type}
        setValue={(val) => {
          handleSelect("type", val);
        }}
        ticketTypes={ticketTypes}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <TicketStatusButton
        status={form?.status}
        setValue={(val) => {
          handleSelect("status", val);
        }}
        defaultGroup={group}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <AssigneeButton
        assignedTo={form?.assignedTo}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <CalendarButton
        dueDate={form?.dueDate}
        onDateChange={(val) => {
          handleSelect("dueDate", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <PriorityButton
        value={form.priority as string}
        setValue={(val) => {
          handleSelect("priority", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
      <TagsButton
        selectedTags={form?.tags}
        onTagsChange={(val) => {
          handleSelect("tags", val);
        }}
        onOpen={() => onOpen()}
        onClose={() => onClose()}
      />
    </>
  );
};

export default Fields;
